import InfoWithPrice from './InfoWithPrice';

export default InfoWithPrice;
